var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _c(
        "w-list-item",
        { attrs: { "show-handle": "" } },
        [
          _c("w-list-item-text", [_vm._v(_vm._s(_vm.asText))]),
          _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.edit"),
                      expression: "$ct('common.edit')",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      return _vm.edit()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "pen" } })],
                1
              ),
            ],
            1
          ),
          _c(
            "w-list-item-action",
            [
              _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("common.delete"),
                      expression: "$ct('common.delete')",
                    },
                  ],
                  staticClass: "danger",
                  attrs: { danger: "" },
                  on: {
                    click: function ($event) {
                      return _vm.deleteItem()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "trash" } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-transition-slide-height",
        { attrs: { mode: "out-in" } },
        [
          _vm.expand
            ? _c(
                "w-card-content",
                [
                  _c("app-item-edit", {
                    attrs: { browse: _vm.browse },
                    model: {
                      value: _vm.value,
                      callback: function ($$v) {
                        _vm.value = $$v
                      },
                      expression: "value",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }